module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-distribution-area"
  }, [_c('div', {
    staticClass: "graph-distribution-area__income-graph"
  }, [_c('pull-down-button', {
    ref: "button1",
    attrs: {
      "text": _vm.incomeGraphText,
      "width": _vm.widthOfGraph
    }
  }, [_c('income-graph', {
    attrs: {
      "data": _vm.incomeData
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-distribution-area__age-market-breakers-graph"
  }, [_c('pull-down-button', {
    ref: "button2",
    attrs: {
      "text": _vm.ageGraphText,
      "width": _vm.widthOfGraph
    }
  }, [_c('age-market-breaker-graph', {
    attrs: {
      "data": _vm.ageMarketBreakerData,
      "meanAge": _vm.meanAge
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "graph-distribution-area__age-distribution-graph"
  }, [_c('pull-down-button', {
    ref: "button3",
    attrs: {
      "text": _vm.ageDistributionText,
      "width": _vm.widthOfGraph
    }
  }, [_c('age-distribution-graph', {
    attrs: {
      "data": _vm.ageData,
      "meanAge": _vm.meanAge
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704ce1a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/distributionGraphs/DistributionGraphArea.vue
// module id = 1948
// module chunks = 0